export const build = { date:"2026-04-30.1223", stage:"alpha" }
